/* Brezza 入口経路の記録 v0.4（2026/11/04：カートに入口を書き込み、注文へ残す）
 * 3) 全ページ：カートに商品があれば、カート属性（_entry_channel／_entry_utm）に入口を書き込む → 注文に残る
 * 1) 全ページ：着地時のUTM・クリックID・参照元をブラウザに保存する
 * 2) カタログ請求ページ：Shopify Forms の入力欄（顧客メタフィールド保存）に値を入れ、欄を非表示にする
 * 注意：Shopify Forms に公式の「隠しフィールド」は無い。Shadow DOM 内の入力欄を外から操作する非公式の方法。
 */
(function () {
  'use strict';

  var CONFIG = window.BREZZA_ENTRY_CONFIG || {
    storageKey: 'brezza_entry_v1',
    keepDays: 90,
    formPagePath: '/pages/catalog-request',
    // Shopify Forms で追加したカスタムフィールドの id（＝「名前空間#キー」）。作成後に実物で確認して合わせる
    fieldChannelId: 'custom#entry_channel',
    fieldDetailId: 'custom#entry_utm',
    // タグの基準： 'last'＝請求直前の最後の広告・外部経路 ／ 'first'＝保存期間内の最初の経路
    basis: 'first',
    waitMs: 30000
  };

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_IDS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'yclid', 'msclkid'];

  function today() {
    var d = new Date();
    function p(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }

  function clean(v) {
    return String(v == null ? '' : v).replace(/[|~\s]+/g, '_').slice(0, 80);
  }

  function refHost() {
    try {
      if (!document.referrer) return '';
      var h = new URL(document.referrer).hostname;
      return h === location.hostname ? '' : h;
    } catch (e) { return ''; }
  }

  // 経路の区分。Brezza の UTM 命名（指示書記載）に合わせている
  function classify(t) {
    var s = (t.src || '').toLowerCase();
    var m = (t.med || '').toLowerCase();
    var c = (t.cmp || '').toLowerCase();
    var id = t.clid || '';
    if (c.indexOf('lyda_') === 0 || id === 'yclid' || /^(yahoo|line|lineyahoo|lyda)/.test(s)) return 'lineyahoo';
    if (id === 'fbclid' || /^(facebook|instagram|meta|fb|ig)$/.test(s)) return 'meta';
    if (id === 'msclkid' || /^(bing|microsoft)$/.test(s)) return 'microsoft';
    if (id === 'gclid' || id === 'gbraid' || id === 'wbraid' || (s === 'google' && /cpc|ppc|paid/.test(m))) return 'google';
    if (s) return 'other';
    if (t.ref) return 'referral';
    return 'direct';
  }

  function currentTouch() {
    var q = new URLSearchParams(location.search);
    var t = {
      src: clean(q.get('utm_source')), med: clean(q.get('utm_medium')), cmp: clean(q.get('utm_campaign')),
      cnt: clean(q.get('utm_content')), trm: clean(q.get('utm_term')),
      clid: '', ref: clean(refHost()), lp: clean(location.pathname), ts: today()
    };
    for (var i = 0; i < CLICK_IDS.length; i++) {
      if (q.has(CLICK_IDS[i])) { t.clid = CLICK_IDS[i]; break; } // 種類だけ保存し、ID の値は保存しない
    }
    t.ch = classify(t);
    return t;
  }

  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(CONFIG.storageKey) || 'null');
      if (!d || !d.exp || d.exp < Date.now()) return null;
      return d;
    } catch (e) { return null; }
  }

  function save(d) {
    try { localStorage.setItem(CONFIG.storageKey, JSON.stringify(d)); } catch (e) { /* 保存不可でもページは動かす */ }
  }

  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
    } catch (e) { /* 判定できなければ保存する */ }
    return true;
  }

  function capture() {
    if (!consentOk()) return load();
    var t = currentTouch();
    var d = load();
    var exp = Date.now() + CONFIG.keepDays * 86400000;
    if (!d) {
      d = { first: t, last: t, exp: exp };
      save(d);
      return d;
    }
    // direct（参照元もUTMも無い再訪）では経路を上書きしない
    if (t.ch !== 'direct') {
      d.last = t;
      if (d.first.ch === 'direct') d.first = t;
    }
    // 再訪のたびに保存期限を延ばす（最後の訪問から keepDays 日残す）
    d.exp = exp;
    save(d);
    return d;
  }

  function touchText(t) {
    return [t.ch, t.src, t.med, t.cmp, t.cnt, t.clid, t.ref, t.lp, t.ts].join('|');
  }

  function values(d) {
    var basis = CONFIG.basis === 'first' ? d.first : d.last;
    return {
      channel: basis.ch,
      detail: ('L:' + touchText(d.last) + ' ~ F:' + touchText(d.first)).slice(0, 900)
    };
  }

  // React が管理する入力欄に、入力と同じ扱いで値を入れる
  function setValue(input, value) {
    if (input.value === value) return;
    var desc = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    desc.set.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  // 欄だけを含む一番外側の要素（ラベルごと）を探す
  function wrapperOf(input, root) {
    var el = input;
    while (el.parentElement && el.parentElement !== root &&
           el.parentElement.querySelectorAll('input, select, textarea, button').length === 1) {
      el = el.parentElement;
    }
    return el;
  }

  function hide(input, root) {
    var w = wrapperOf(input, root);
    if (w === input) return; // 包む要素を特定できないときは隠さない（他の欄を巻き込まない）
    w.style.setProperty('display', 'none', 'important');
    w.setAttribute('aria-hidden', 'true');
    input.setAttribute('tabindex', '-1');
    input.setAttribute('autocomplete', 'off');
  }

  function applyTo(root, d) {
    var v = values(d);
    var done = 0;
    var a = root.getElementById(CONFIG.fieldChannelId);
    var b = root.getElementById(CONFIG.fieldDetailId);
    if (a) { setValue(a, v.channel); hide(a, root); done++; }
    if (b) { setValue(b, v.detail); hide(b, root); done++; }
    return done;
  }

  function fillForm(d) {
    var started = Date.now();
    var timer = setInterval(function () {
      var hosts = document.querySelectorAll('shopify-forms-embed');
      var filled = 0;
      for (var i = 0; i < hosts.length; i++) {
        var root = hosts[i].shadowRoot;
        if (!root) continue;
        filled += applyTo(root, d);
        if (!hosts[i].__brezzaEntryBound) {
          hosts[i].__brezzaEntryBound = true;
          // 送信ボタンを押した瞬間にも入れ直す（再描画で値が消えた場合の保険）
          root.addEventListener('click', function (ev) {
            var btn = ev.target && ev.target.closest ? ev.target.closest('button[type="submit"]') : null;
            if (btn) applyTo(this, d);
          }, true);
        }
      }
      // 欄が見つかっても、再描画に備えて waitMs の間は入れ直しを続ける
      if (Date.now() - started > CONFIG.waitMs) clearInterval(timer);
      window.__brezzaEntryFilled = filled;
    }, 500);
  }

  // カートに商品があるとき、カート属性に入口を書き込む（注文の「追加情報」に残る）
  function syncCart(d) {
    if (!d || !window.fetch) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var v = values(d);
    var want = { '_entry_channel': v.channel, '_entry_utm': v.detail };
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return; // 空のカートには書かない（カートを新しく作らない）
        var a = cart.attributes || {};
        if (a._entry_channel === want._entry_channel && a._entry_utm === want._entry_utm) return;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: want })
        });
      })
      .then(function () { window.__brezzaEntryCart = 'ok'; })
      .catch(function () { window.__brezzaEntryCart = 'error'; }); // 失敗してもページは動かす
  }

  var data = capture();
  window.__brezzaEntry = data;
  syncCart(data);
  if (data && location.pathname.indexOf(CONFIG.formPagePath) === 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { fillForm(data); });
    } else {
      fillForm(data);
    }
  }
})();